class TimeCountdown {
  constructor() {
    this.countdowns = document.querySelectorAll('.time-countdown');
    this.init();
  }

  init() {
    this.countdowns.forEach(countdown => {
      this.startCountdown(countdown);
    });
  }

  startCountdown(element) {
    const endDate = element.dataset.endDate;
    const endTime = element.dataset.endTime;

    if (!endDate || !endTime) {
      console.warn('Time countdown missing date or time');
      return;
    }

    // Use PacificTimezoneHelper for consistent timezone handling
    const endDateTime = window.PacificTimezoneHelper 
      ? window.PacificTimezoneHelper.parsePacificTime(endDate, endTime)
      : this.parsePacificTimeFallback(endDate, endTime);

    // Update immediately
    this.updateCountdown(element, endDateTime);

    // Update every second
    const interval = setInterval(() => {
      const isExpired = this.updateCountdown(element, endDateTime);
      if (isExpired) {
        clearInterval(interval);
      }
    }, 1000);
  }

  parsePacificTimeFallback(dateStr, timeStr) {
    // Fallback method if PacificTimezoneHelper is not available
    const tempDate = new Date(`${dateStr}T${timeStr}:00`);
    const isPDT = this.isDaylightSavingTime(tempDate);
    const offset = isPDT ? '-07:00' : '-08:00';
    return new Date(`${dateStr}T${timeStr}:00${offset}`);
  }

  isDaylightSavingTime(date) {
    // Check if the date falls during daylight saving time in US
    // DST typically runs from second Sunday in March to first Sunday in November
    const year = date.getFullYear();
    
    // Find second Sunday in March
    const marchStart = new Date(year, 2, 1); // March 1
    const marchSecondSunday = new Date(year, 2, (14 - marchStart.getDay()));
    
    // Find first Sunday in November
    const novStart = new Date(year, 10, 1); // November 1
    const novFirstSunday = new Date(year, 10, (7 - novStart.getDay() + 1));
    
    return date >= marchSecondSunday && date < novFirstSunday;
  }

  updateCountdown(element, endDateTime) {
    const now = new Date();
    const timeRemaining = endDateTime - now;

    // Check if expired
    if (timeRemaining <= 0) {
      this.showExpiredMessage(element);
      return true; // Expired
    }

    // Calculate total hours and remaining minutes
    const totalSeconds = Math.floor(timeRemaining / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    // Ensure minimum 2 digits for display
    const hoursPadded = hours.toString().padStart(2, '0');
    const minutesPadded = minutes.toString().padStart(2, '0');
    
    // Update display - dynamically handle any number of hour digits
    this.updateDigitDisplay(element, hoursPadded, 'hours');
    this.updateDigitDisplay(element, minutesPadded, 'minutes');

    return false; // Not expired
  }

  updateDigitDisplay(element, paddedValue, type) {
    // Get the display container
    const display = element.querySelector('.time-countdown__display');
    if (!display) return;

    // Find existing digit containers for this type
    const existingDigits = display.querySelectorAll(`.time-countdown__${type}-digit`);
    const digitCount = paddedValue.length;

    // If we need more digit containers than we have, rebuild the hours section
    if (existingDigits.length !== digitCount) {
      this.rebuildDigitContainers(display, type, digitCount);
    }

    // Update each digit
    const digits = display.querySelectorAll(`.time-countdown__${type}-digit`);
    for (let i = 0; i < paddedValue.length; i++) {
      const digitElement = digits[i];
      if (digitElement) {
        const valueElement = digitElement.querySelector('.time-countdown__digit-value');
        if (valueElement) {
          valueElement.textContent = paddedValue[i];
        }
      }
    }
  }

  rebuildDigitContainers(display, type, digitCount) {
    // Remove old digit containers for this type
    const oldDigits = display.querySelectorAll(`.time-countdown__${type}-digit`);
    oldDigits.forEach(digit => digit.remove());

    // Find the separator to know where to insert
    const separator = display.querySelector('.time-countdown__separator');
    
    // Create new digit containers
    for (let i = 0; i < digitCount; i++) {
      const digitDiv = document.createElement('div');
      digitDiv.className = `time-countdown__digit time-countdown__${type}-digit`;
      
      const valueSpan = document.createElement('span');
      valueSpan.className = 'time-countdown__digit-value';
      valueSpan.textContent = '0';
      
      digitDiv.appendChild(valueSpan);
      
      // Insert before separator for hours, after for minutes
      if (type === 'hours') {
        display.insertBefore(digitDiv, separator);
      } else {
        display.appendChild(digitDiv);
      }
    }
  }


  showExpiredMessage(element) {
    const display = element.querySelector('.time-countdown__display');
    const label = element.querySelector('.time-countdown__label');
    const expiredMessage = element.querySelector('.time-countdown__expired');

    if (display) display.style.display = 'none';
    if (label) label.style.display = 'none';
    if (expiredMessage) expiredMessage.style.display = 'block';
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TimeCountdown();
  });
} else {
  new TimeCountdown();
}

// Re-initialize on Shopify section re-render
document.addEventListener('shopify:section:load', () => {
  new TimeCountdown();
});

